/* eslint-disable @next/next/no-img-element */
'use client';

import React, { useMemo } from 'react';

import { ChevronTightRight } from '@repo/ui/components/icons/chevron-tight-right';
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from '@repo/ui/components/ui/avatar';
import { secondsToTimestamp } from '@repo/utils';

import { YtVideoCardTitle } from './yt-video-card-title';

interface YtVideoCardContentProps {
  title: string;
  videoThumbnail?: string | null;
  channelThumbnail?: string | null;
  channelName?: string | null;
  duration: number;
  viewCount: number | null;
  credibilityScore: number;
}

export const YtVideoCardContent: React.FC<YtVideoCardContentProps> = ({
  title,
  videoThumbnail,
  channelThumbnail,
  channelName,
  duration,
  viewCount,
  // credibilityScore,
}) => {
  const channelNameInitial = useMemo(() => {
    if (!channelName) return 'VC';
    const firstName = channelName.split(' ')[0] ?? '';
    const lastName = channelName.split(' ')[1] ?? '';
    return `${firstName.charAt(0).toUpperCase()}${lastName.charAt(0).toUpperCase()}`;
  }, [channelName]);

  return (
    <div className="space-y-1 cred-md:space-y-1.5">
      <div className="relative overflow-hidden group cursor-pointer">
        <img
          src={videoThumbnail || undefined}
          alt={title}
          className="w-full aspect-video object-cover"
        />
        <div className="absolute bottom-2 right-2 bg-black/90 text-white text-xs font-semibold px-1.5 py-0.5 rounded">
          {secondsToTimestamp(duration, 'simple')}
        </div>
      </div>

      <div className="flex items-start gap-2 px-1.5">
        <Avatar className="size-6 md:size-8 shrink-0">
          <AvatarImage
            src={channelThumbnail || undefined}
            alt="Video channel"
          />
          <AvatarFallback className="text-white">
            {channelNameInitial}
          </AvatarFallback>
        </Avatar>

        <YtVideoCardTitle title={title} viewCount={viewCount} />

        <div className="flex items-center justify-end gap-1.5">
          {/* <div className="bg-[#2979ff] flex size-fit rounded-sm px-1 py-[3px] cred-lg:py-1.5 shadow-[inset_1px_2px_4px_rgba(62,62,62,0.25)] transition-opacity duration-300">
            <span className="block w-10 text-center text-[15px] cred-lg:text-base cred-xl:text-[17px] font-medium leading-4 tracking-wide text-white">
              {Math.round(credibilityScore ?? 0)}%
            </span>
          </div> */}
          <ChevronTightRight className="h-9 w-4 text-neutral-2" />
        </div>
      </div>
    </div>
  );
};
